// Components
import { useState, useCallback, useEffect } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OrderCard from '../../OrderCard';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../../Alert';
import SectionTitle from '../../SectionTitle';

// Styles
import styles from './index.module.sass';
import { styled } from '@mui/material/styles';

//Queries
import postContrato from '../../Queries/postContrato';
import validateRFC from '../../Queries/validateRFC';
import getSepomex from '../../Queries/getSepomex';
import getCookie from '../../Queries/getCookie';

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 120,
    backgroundColor: '#002747',
  },
});

export default function ContractMX(props) {
  const { device, setSessionMessage, history } = props;
  const screenSize = device?.screenSize || 'desktop';
  const { t } = useTranslation('contractMX');
  const tooltipText = t('tootip');
  const [errorsArr, setErrorsArr] = useState([]);
  const [checkErr, setCheckErr] = useState({});
  const [errorsObj, setErrorsObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [sexos, setSexos] = useState({});
  const [kitPatrocinadora, setKitPatrocinadora] = useState('');
  const [msjErr, setmsjErr] = useState('');
  const [typeInput, settypeInput] = useState('password');
  const [arrayColonias, setColonias] = useState([]);
  const [kitValidate, setkitValidate] = useState(false);
  const [loadingKit, setLoadingKit] = useState(false);
  const [ResponseRFC, setResponseRFC] = useState('RFC Valido');
  const [valuesForm, setvaluesForm] = useState({
    kit: '',
    nombre: '',
    paterno: '',
    materno: '',
    birthday: '',
    email: '',
    sexo: '',
    rfc: 'XAXX010101000',
    calle: '',
    numeroExterior: '',
    numeroInterior: '',
    manzana: '',
    edificio: '',
    lote: '',
    depCasa: '',
    cp: '',
    colonia: '',
    estadoDescri: '',
    entreCalle: '',
    yLaCalle: '',
    telefonoCasa: '',
    celular: '',
    telefonoOficina: '',
    password: '',
    confirmPassword: '',
    pais: process.env.REACT_APP_COUNTRY,
    kitPatrocinadora: getCookie('usuarioOk'),
  });

  const [recordSuccess, setRecordSuccess] = useState({});
  const [showWelcome, setShowWelcome] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  const fetchData = useCallback(() => {
    let listaSexos = [];
    listaSexos.push({
      value: '1',
      label: 'Femenino',
    });

    setSexos(listaSexos);
  }, []);

  const getPatroName = useCallback(async () => {
    const resp = await postContrato({
      jsonBody: {
        accion: 'CONTINUAR',
        kitPatrocinadora: valuesForm?.kitPatrocinadora || '',
        pais: valuesForm.pais,
      },
    });

    const { mensaje, nombrePatrocinadora = '' } = resp;
    setKitPatrocinadora(nombrePatrocinadora);
    setSessionMessage(mensaje);
  }, [setSessionMessage, valuesForm?.kitPatrocinadora, valuesForm.pais]);

  useEffect(() => {
    getPatroName();
    fetchData();
  }, [fetchData, getPatroName]);

  const changeValue = (e, type) => {
    setErrorsArr([]);
    let value = e.target.value.toUpperCase();
    if (e.target.name === 'colonia') value = e.target.value;
    if (e.target.name === 'email') value = e.target.value.toLowerCase();

    if (e.target.name === 'rfc') {
      valuesForm.rfcValido = '';
      setResponseRFC('RFC No Valido');

      setButtonDisabled(true);
    }
    if (e.target.name === 'kitPatrocinadora') {
      value = value.replace(
        /[`~´!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}abcdefghijklmnopqrstuvwxyz[\]\\/ ]/gi,
        '',
      );

      getPatroName();
    }

    if (e.target.name === 'nombre' || e.target.name === 'paterno' || e.target.name === 'materno') {
      value = value.replace(
        /[0-9`~´!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ω{}[\]\\/]/gi,
        '',
      );

      value = value.replace(/[ñ]/gi, 'N');
    }

    if (e.target.name === 'password') {
      value = value.replace(
        /[`~´!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}[\]\\/ ]/gi,
        '',
      );
      if (value.length < 5) {
        setmsjErr(t('errPassword'));
        setButtonDisabled(true);
        e.target.focus();
      } else {
        setmsjErr('');
        setButtonDisabled(false);
      }
    }

    if (e.target.name === 'confirmPassword') {
      value = value.replace(
        /[`~´!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}[\]\\/ ]/gi,
        '',
      );
      if (valuesForm.password !== e.target.value) {
        setmsjErr(t('errPassword2'));

        setButtonDisabled(true);
      } else {
        setmsjErr('');

        setButtonDisabled(false);
      }
    }
    if (e.target.name === 'kitPatrocinadora') {
      if (valuesForm.Kit !== '') {
        setkitValidate(false);
        verifyKIT();
      }
    }

    setvaluesForm({
      ...valuesForm,
      [e.target.name]: value,
    });

    let tmpObj = Object.assign({}, errorsObj);
    delete tmpObj[e.target.name];
    setErrorsObj(tmpObj);
  };

  const onBlur = (e) => {
    let value = e.target.value;
    let usuarioOK = '9000000';

    if (e.target.name === 'password') {
      if (value.search('TE') >= 0) {
        setmsjErr(t('errPassword3'));
        setButtonDisabled(true);

        e.target.focus();
        return;
      } else {
        setmsjErr('');
      }

      if (value === usuarioOK) {
        setmsjErr(t('errPassword4'));
        setButtonDisabled(true);
        e.target.focus();
        return;
      } else {
        setmsjErr('');
      }
    }

    if (e.target.name === 'confirmPassword') {
      if (valuesForm.password !== e.target.value) {
        setmsjErr(t('errPassword2'));

        setButtonDisabled(true);
      } else {
        setmsjErr('');
        if (valuesForm.confirmPassword.length === e.target.length) {
          setmsjErr('');
        }

        setButtonDisabled(false);
      }
    }

    if (e.target.name === 'kitPatrocinadora') {
      //getPatroName({ kitPatrocinadora: value, setKitPatrocinadora, valuesForm });
      getPatroName();
    }

    let tmpObj = Object.assign({}, checkErr);

    if (e.target.value.trim() === '') tmpObj = { ...checkErr, [e.target.name]: true };
    else delete tmpObj[e.target.name];

    setErrorsObj(tmpObj);
    setCheckErr(tmpObj);
  };

  const onSubmit = async () => {
    if (valuesForm.nombre === '') {
      setAlertText(t('alertName'));
      setOpen(true);
      return;
    }

    if (valuesForm.paterno === '') {
      setAlertText(t('alertPaterno'));
      setOpen(true);
      return;
    }

    if (valuesForm.materno === '') {
      setAlertText(t('alertMaterno'));
      setOpen(true);
      return;
    }

    if (valuesForm.birthday === '') {
      setAlertText(t('alertBirthday'));
      setOpen(true);
      return;
    }

    if (valuesForm.email === '') {
      setAlertText(t('alertEmail'));
      setOpen(true);
      return;
    }

    if (valuesForm.sexo === '') {
      setAlertText(t('alertSexo'));
      setOpen(true);
      return;
    }

    if (valuesForm.rfc === '') {
      setAlertText(t('alertRFC'));
      setOpen(true);
      return;
    }

    if (valuesForm.calle === '') {
      setAlertText(t('alertCalle'));
      setOpen(true);
      return;
    }

    if (valuesForm.numeroExterior === '') {
      setAlertText(t('alertNumExt'));
      setOpen(true);
      return;
    }

    if (valuesForm.cp === '') {
      setAlertText(t('alertCP'));
      setOpen(true);
      return;
    }

    if (valuesForm.colonia === '') {
      setAlertText(t('alertColonia'));
      setOpen(true);
      return;
    }

    if (valuesForm.telefonoCasa === '') {
      setAlertText(t('alertPhone'));
      setOpen(true);
      return;
    }

    if (valuesForm.celular === '') {
      setAlertText(t('alertCellPhone'));
      setOpen(true);
      return;
    }

    if (valuesForm.password === '') {
      setAlertText(t('alertPassword'));
      setOpen(true);
      return;
    }

    if (valuesForm.confirmPassword === '') {
      setAlertText(t('alertConfirmPassword'));
      setOpen(true);
      return;
    }

    if (valuesForm.kitPatrocinadora === '') {
      setAlertText(t('alertKit'));
      setOpen(true);
      return;
    }

    if (ResponseRFC === 'RFC No Valido') {
      setAlertText(ResponseRFC);
      setOpen(true);

      setButtonDisabled(true);
      return;
    }

    if (valuesForm.password.length < 5) {
      setmsjErr(t('errPassword'));
      setOpen(true);

      setButtonDisabled(true);
      return;
    } else {
      setmsjErr('');

      setButtonDisabled(false);
    }

    setLoading(true);

    const birthdayDate = valuesForm.birthday.split('-');

    const jsonBody = {
      ...valuesForm,
      usuarioOK: '9000000',
      accion: 'TERMINAR',
      fechaNacAnio: birthdayDate[0] || '',
      fechaNacMes: birthdayDate[1] || '',
      fechaNacDia: birthdayDate[2] || '',
      rfcValido: 'S',
      acepto: 'S',
    };

    const resp = await postContrato({ jsonBody });
    const { accionSiguiente, rfcValido, tipoMensaje, mensajeValidacionDatos, mensaje } = resp;

    setLoading(false);
    setSessionMessage(mensaje);

    if (accionSiguiente === 'FIN' && rfcValido === 'S' && tipoMensaje === 'exito') {
      setAlertText(t('alertSucces'));
      setOpen(true);
      setRecordSuccess(resp);
      setShowWelcome(true);
    } else {
      setAlertText(mensajeValidacionDatos);
      setOpen(true);
      setErrorsArr([...errorsArr, mensajeValidacionDatos]);
      window.scrollTo(0, 0);
    }
  };

  function seePsw() {
    if (typeInput === 'password') {
      settypeInput('text');
    } else {
      settypeInput('password');
    }
  }

  async function verifyCP(e) {
    let cp = e.target.value;
    if (cp.length !== 5) {
      setAlertText(t('correctionCP'));
      setOpen(true);
      return;
    } else {
      setLoading(true);
      const response = await getSepomex(cp);
      const { mensaje, colonias, estado } = response;
      setSessionMessage(mensaje);
      if (mensaje === '') {
        valuesForm.estadoDescri = estado;
        let col = [];
        for (let index = 0; index < colonias.length; index++) {
          col.push(colonias[index].colonia);
        }
        setColonias(col);
        setLoading(false);
      } else {
        setAlertText(mensaje);
        setOpen(true);
        setLoading(false);
      }
    }
  }

  async function verifyKIT() {
    if (valuesForm.numkit !== '' && !kitValidate) {
      setLoadingKit(true);
      const jsonBody = {
        accion: 'CONTINUAR',
        usuarioOK: '9000000',
        kitPatrocinadora: valuesForm.Kit,
      };
      const resp = await postContrato({ jsonBody });
      const { nombrePatrocinadora, mensaje } = resp;
      setSessionMessage(mensaje);
      if (nombrePatrocinadora === '** Patrocinadora no existe') {
        setLoadingKit(false);
        return;
      } else {
        setLoadingKit(false);
        setkitValidate(true);
      }
    }
  }

  function restrictChars($event) {
    if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
      return true;
    } else {
      $event.preventDefault();
    }
  }

  function requiredInput(id) {
    var campo = document.getElementById(id);
    var label = document.getElementById('required' + id);
    if (campo.value === '') {
      campo.className = styles.inputTextError;
      campo.style.borderColor = 'red';
      label.innerHTML = '*Campo obligatorio';
    } else {
      campo.style.borderColor = '#758893';
      label.innerHTML = '';
    }
  }

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <Alert open={open} setOpen={setOpen} title={t('titleAlert')} text={alertText} />
      {errorsArr.length > 0 && (
        <div className={styles.errorsContainer}>
          {errorsArr.map((err, key) => {
            return <div key={key}>{err}</div>;
          })}
        </div>
      )}
      <div>&nbsp;</div>

      {!showWelcome ? (
        <div>
          <SectionTitle title={t('captureGold')} subtitle={t('captureBlue')} />
          <OrderCard>
            <div className={styles.orderDet}>
              <div className={styles.cardText}>
                <div className={styles.textIcon}>
                  <i className={`material-icons-outlined ${styles.icon}`}>account_box </i>
                  <label className={styles.iconText}>{t('PersonalData')}</label>
                </div>
              </div>
              <div className={styles.item} name='RowName'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('Name')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='nombre'
                      id='nombre'
                      value={valuesForm.nombre || ''}
                      maxLength='34'
                      onBlur={() => requiredInput('nombre')}
                    />
                    <div id='requirednombre' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('lastName')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='paterno'
                      id='paterno'
                      value={valuesForm.paterno || ''}
                      maxLength='34'
                      onBlur={() => requiredInput('paterno')}
                    />
                    <div id='requiredpaterno' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('secondName')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='materno'
                      id='materno'
                      value={valuesForm.materno || ''}
                      maxLength='34'
                      onBlur={() => requiredInput('materno')}
                    />
                    <div id='requiredmaterno' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.item} name='RowMail'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <label className={styles.labelBlue}>{t('dateOfBirth')}*</label>
                    <input
                      type='date'
                      placeholder={t('dateOfBirth')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='birthday'
                      id='birthday'
                      value={valuesForm.birthday || ''}
                      shrink='true'
                      onBlur={((e) => onBlur(e), (e) => requiredInput('birthday'))}
                      maxLength='34'
                    />
                    <div id='requiredbirthday' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <label className={styles.label}>Correo electronico</label>
                    <input
                      type='mail'
                      placeholder={t('mail')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='email'
                      id='email'
                      value={valuesForm.email || ''}
                      maxLength='50'
                      onBlur={() => requiredInput('email')}
                    />
                    <div id='requiredemail' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDivSexo}>
                    <label className={styles.labelBlue}>Sexo*:</label>
                    <select
                      className={styles.selectText}
                      onChange={(e) => changeValue(e)}
                      value={valuesForm.sexo || ''}
                      name='sexo'
                      id='sexo'
                      onBlur={((e) => onBlur(e), () => requiredInput('sexo'))}>
                      <option value=''>{t('placeholder')} </option>

                      {sexos.length > 0 &&
                        sexos.map((val, key) => {
                          return (
                            <option key={key} value={val.value}>
                              {val.label}
                            </option>
                          );
                        })}
                    </select>
                    <div id='requiredsexo' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.item} name='RowRfc'>
                <div className={styles.title}>
                  <div className={styles.inputDivRFC}>
                    <input
                      type='text'
                      placeholder='RFC*'
                      className={styles.inputTextRFC}
                      onChange={(e) => changeValue(e)}
                      name='rfc'
                      id='rfc'
                      value={valuesForm.rfc || ''}
                      onBlur={((e) => onBlur(e), () => requiredInput('rfc'))}
                      maxLength='34'
                    />
                    <div id='requiredrfc' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDivRFC}>
                    <Button
                      variant='contained'
                      size='large'
                      color='primary'
                      className={styles.button}
                      onClick={async (e) => {
                        if (loading) return;
                        setLoading(true);
                        const response = await validateRFC({
                          valuesForm,
                          type: 'N',
                        });
                        if (
                          response.formatoCorrecto === true &&
                          response.localizado === true &&
                          response.activo === true
                        ) {
                          setResponseRFC('RFC Valido');

                          setButtonDisabled(false);
                        } else {
                          setResponseRFC('RFC No Valido');

                          setButtonDisabled(true);
                        }
                        setLoading(false);
                      }}>
                      {(loading && <CircularProgress className={styles.circularProgress} />) ||
                        t('buttonValidate')}
                    </Button>
                  </div>
                  <div
                    className={
                      ResponseRFC === 'RFC Valido' ? styles.rfcValidate : styles.rfcNoValidate
                    }>
                    {ResponseRFC}
                  </div>
                </div>
              </div>

              <div className={styles.cardText}>
                <div className={styles.textIcon}>
                  <i className={`material-icons-outlined ${styles.icon}`}>house </i>
                  <label className={styles.iconText}>{t('home')}</label>
                </div>
              </div>
              <div className={styles.item} name='RowAddress'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('street')}
                      className={styles.inputTextAddress}
                      onChange={(e) => changeValue(e)}
                      name='calle'
                      id='calle'
                      value={valuesForm.calle || ''}
                      onBlur={((e) => onBlur(e), () => requiredInput('calle'))}
                      maxLength='34'
                    />
                    <div id='requiredcalle' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={`${t('externalNumber')}*`}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='numeroExterior'
                      id='numeroExterior'
                      value={valuesForm.numeroExterior || ''}
                      onBlur={((e) => onBlur(e), () => requiredInput('numeroExterior'))}
                      maxLength='34'
                    />
                    <div id='requirednumeroExterior' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={`${t('internalNumber')}*`}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='numeroInterior'
                      value={valuesForm.numeroInterior || ''}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.item} name='RowMza'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('zone')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='manzana'
                      value={valuesForm.manzana || ''}
                    />
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('Edifice')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='edificio'
                      value={valuesForm.edificio || ''}
                    />
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('lote')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='lote'
                      value={valuesForm.lote || ''}
                      maxLength='34'
                    />
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('dpto')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='depCasa'
                      value={valuesForm.depCasa || ''}
                      maxLength='34'
                    />
                  </div>
                </div>
              </div>
              <div className={styles.item} name='RowCp'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('cp')}
                      className={styles.inputText}
                      name='cp'
                      id='cp'
                      autoComplete='off'
                      onBlur={(e) => {
                        requiredInput('cp');
                        verifyCP(e);
                      }}
                      maxLength='5'
                      onKeyPress={(e) => restrictChars(e)}
                      onChange={(e) => changeValue(e)}
                      value={valuesForm.cp || ''}
                    />
                    <div id='requiredcp' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDivSexo}>
                    <select
                      className={styles.selectText}
                      name='colonia'
                      id='colonia'
                      onChange={(e) => changeValue(e)}
                      value={valuesForm.colonia || ''}
                      onBlur={(e) => requiredInput('colonia')}>
                      <option value=''>{t('placeholder')}</option>
                      {arrayColonias.map((val, key) => {
                        return (
                          <option key={key} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>
                    <div id='requiredcolonia' className={styles.redLabel}>
                      &nbsp;
                    </div>
                    {loading && (
                      <div className={styles.loading}>
                        <CircularProgress className={styles.circularProgressBlue} /> <br />
                        {t('colonias')}
                      </div>
                    )}
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('state')}
                      className={styles.inputText}
                      disabled={true}
                      value={valuesForm.estadoDescri || ''}
                      onChange={(e) => changeValue(e)}
                      name='estadoDescri'
                    />
                  </div>
                </div>
              </div>
              <div className={styles.item} name='RowEntre'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('street1')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='entreCalle'
                      value={valuesForm.entreCalle || ''}
                      maxLength='34'
                    />
                  </div>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('street2')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='yLaCalle'
                      value={valuesForm.yLaCalle || ''}
                      maxLength='34'
                    />
                  </div>
                  <div className={styles.inputDiv}>&nbsp;</div>
                </div>
              </div>

              <div className={styles.cardText}>
                <div className={styles.textIcon}>
                  <i className={`material-icons-outlined ${styles.icon}`}>contact_phone</i>
                  <label className={styles.iconText}>{t('contact')}</label>
                </div>
              </div>
              <div className={styles.item} name='RowContact'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('tel1')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='telefonoCasa'
                      id='telefonoCasa'
                      value={valuesForm.telefonoCasa || ''}
                      maxLength='10'
                      onBlur={() => requiredInput('telefonoCasa')}
                    />
                    <div id='requiredtelefonoCasa' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('tel2')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='celular'
                      id='celular'
                      value={valuesForm.celular || ''}
                      maxLength='10'
                      onBlur={() => requiredInput('celular')}
                    />
                    <div id='requiredcelular' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      type='text'
                      placeholder={t('office')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='telefonoOficina'
                      value={valuesForm.telefonoOficina || ''}
                      maxLength='10'
                    />
                  </div>
                </div>
              </div>

              <div className={styles.cardText}>
                <div className={styles.textIcon}>
                  <i className={`material-icons-outlined ${styles.icon}`}>password</i>
                  <label className={styles.iconText}>{t('createPass')}*</label>
                </div>
              </div>
              <div className={styles.item} name='RowPassword'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      placeholder={t('createPass')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='password'
                      id='password'
                      type={typeInput}
                      value={valuesForm.password || ''}
                      onBlur={(e) => {
                        requiredInput('password');
                        onBlur(e);
                      }}
                      maxLength='10'
                    />
                    <div id='requiredpassword' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDiv}>
                    <input
                      placeholder={t('confirmPass')}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='confirmPassword'
                      id='confirmPassword'
                      type={typeInput}
                      value={valuesForm.confirmPassword || ''}
                      onBlur={(e) => {
                        requiredInput('confirmPassword');
                        onBlur(e);
                      }}
                      maxLength='10'
                    />
                    <div id='requiredconfirmPassword' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>

                  <div className={styles.inputDivPassword}>
                    <div className={styles.errorStyle}> {msjErr}</div>
                    <CustomWidthTooltip title={tooltipText} placement='right' arrow>
                      {<span className={`material-icons-outlined ${styles.tooltip}`}>info</span>}
                    </CustomWidthTooltip>

                    {(typeInput === 'password' && (
                      <i
                        className={`material-icons ${styles.checkPassword}`}
                        onClick={() => seePsw()}>
                        check_box_outline_blank
                      </i>
                    )) || (
                      <i
                        className={`material-icons ${styles.checkPassword}`}
                        onClick={() => seePsw()}>
                        check_box
                      </i>
                    )}
                    <label className={styles.checkPassword}>{t('showPass')}</label>
                  </div>
                </div>
              </div>
              <div className={styles.item} name='RowKitPatrocinio'>
                <div className={styles.title}>
                  <div className={styles.inputDiv}>
                    <input
                      type='number'
                      placeholder={`${t('sponsor')}*`}
                      className={styles.inputText}
                      onChange={(e) => changeValue(e)}
                      name='kitPatrocinadora'
                      id='kitPatrocinadora'
                      value={valuesForm.kitPatrocinadora || ''}
                      onBlur={(e) => {
                        requiredInput('kitPatrocinadora');
                        onBlur(e);
                      }}
                    />
                    <div id='requiredkitPatrocinadora' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>
                  <div className={styles.inputDiv}>
                    <select
                      className={styles.selectText}
                      onChange={(e) => changeValue(e)}
                      value={valuesForm.pais || ''}
                      name='pais'
                      id='pais'
                      onBlur={((e) => onBlur(e), () => requiredInput('pais'))}>
                      <option value='MX'>{t('placeholderPaisMX')}</option>
                      <option value='US'>{t('placeholderPaisUS')}</option>
                    </select>
                    <div id='requiredpais' className={styles.redLabel}>
                      &nbsp;
                    </div>
                  </div>
                  {screenSize === 'desktop' && <div className={styles.inputDiv}>&nbsp;</div>}
                </div>
              </div>
              <div className={styles.title}>
                <div className={styles.inputDiv}>
                  {loadingKit && (
                    <div className={styles.loading}>
                      <CircularProgress className={styles.circularProgressBlue} />
                    </div>
                  )}
                  <div>
                    <div className={styles.patroName}>{kitPatrocinadora}&nbsp;</div>
                  </div>
                </div>
              </div>

              <div className={styles.item}>
                <div className={styles.inputDiv}>
                  <Button
                    variant='contained'
                    size='large'
                    color='primary'
                    className={`${(buttonDisabled && styles.disabled) || styles.buttonSave} ${
                      styles.buttonSave
                    }`}
                    onClick={(e) => {
                      if (!buttonDisabled && !loading) {
                        onSubmit(e);
                      }
                    }}>
                    {(loading && <CircularProgress className={styles.circularProgress} />) ||
                      t('continue')}
                  </Button>
                </div>
              </div>

              <div className={styles.itemFooter}>
                <label className={styles.footer}>
                  {t('labelFooter')}&nbsp;
                  <label
                    className={styles.links}
                    onClick={() => window.open('https://www.terramarbrands.com.mx/privacy/')}>
                    {t('privacy')}
                  </label>
                  &nbsp;{t('labelFooter2')}&nbsp;
                  <label
                    className={styles.links}
                    onClick={() => window.open('https://www.terramarbrands.com.mx/terms/')}>
                    {t('terms')}
                  </label>
                </label>
              </div>
            </div>
          </OrderCard>
        </div>
      ) : (
        <div>
          <div className={styles.goldTitle}>{t('welcomeGold')}</div>
          <div className={styles.blueSubtitle}>{t('welcomeBlue')}</div>
          <div className={styles.titleWelcome}>{t('textSuccess2')}</div>

          <OrderCard>
            <div className={styles.blackLabel}>{t('success1')}</div>
            <div className={styles.textSuccess}>{t('textSuccess')}</div>
            <div className={styles.verify}>
              <div className={styles.validateSMS} onClick={() => history.push('validate')}>
                <span className={`material-icons`}>verified</span>
                <label className={styles.underline}>{t('validateCode')}</label>
              </div>
            </div>
          </OrderCard>

          <OrderCard>
            <div className={styles.numKit}>
              <label className={styles.blackLabel}>
                {t('numKit')} {recordSuccess.kit} - {recordSuccess.digitoVerificador}
              </label>
            </div>
            <br />
            <div className={styles.textSuccess}>{t('msj')}</div>
            <div className={styles.textSuccess}>
              <label className={styles.labelGold}>Nombre:</label>
              <label className={styles.blackLabel}>{recordSuccess.nombreCompleto}</label>
              <br /> <label className={styles.labelGold}>KIT:</label>{' '}
              <label className={styles.blackLabel}>TE{recordSuccess.kit} </label> <br />{' '}
              <label className={styles.labelGold}>{t('labelPass')}</label>
              <label className={styles.blackLabel}>{recordSuccess.contrasenia}</label>
            </div>
            <br />
            <div className={styles.textSuccess}>{t('note')}</div>
            <br />
            <div className={styles.finishButton}>
              <Button
                variant='contained'
                color='primary'
                className={styles.buttonFinish}
                onClick={(e) => setShowWelcome(false)}>
                Terminar
              </Button>
            </div>
          </OrderCard>
        </div>
      )}
    </div>
  );
}
